/**
 * @generated SignedSource<<628dc56a22bc95a346c5aa65bac6a8b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteGeneralAssetManufacturerInput = {
  generalAssetManufacturerId: string;
  clientMutationId?: string | null;
};
export type GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation$variables = {
  input: DeleteGeneralAssetManufacturerInput;
};
export type GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutationVariables = GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation$variables;
export type GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation$data = {
  readonly deleteGeneralAssetManufacturer: {
    readonly generalAssetManufacturer: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutationResponse = GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation$data;
export type GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation = {
  variables: GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutationVariables;
  response: GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGeneralAssetManufacturerPayload",
    "kind": "LinkedField",
    "name": "deleteGeneralAssetManufacturer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralAssetManufacturer",
        "kind": "LinkedField",
        "name": "generalAssetManufacturer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "79ad171719003b8f1fb9d070da1f1858",
    "id": null,
    "metadata": {},
    "name": "GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation",
    "operationKind": "mutation",
    "text": "mutation GeneralAssetManufacturersTableDeleteGeneralAssetManufacturerMutation(\n  $input: DeleteGeneralAssetManufacturerInput!\n) {\n  deleteGeneralAssetManufacturer(input: $input) {\n    generalAssetManufacturer {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea39ae3239473bfcaf86c904ddcb7927";

export default node;
